const WIDGET_VERSION = "latest";
export const CDN_URL = `https://cdn.jsdelivr.net/npm/vviinn-widgets@${WIDGET_VERSION}/www/build/`;
